// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   TextField,
//   Button,
// } from "@mui/material";
// import HotListDrawer from "./HotListDrawer";
// import { getAssignedOrPublishedHotLists } from "../../redux/hotlist/hotListRecSlice";
// import { useDispatch, useSelector } from "react-redux";
// import { shortDateTime } from "../../utils/const";

// const HotlistItRec = () => {
//   const dispatch = useDispatch();
//   const [showDrawer, setShowDrawer] = useState(false);
//   const [selectedHotlist, setSelectedHotlist] = useState(null);
//   const hotlists = useSelector((state) => state.hotlistrec.hotLists);
//   const loading = useSelector(
//     (state) => state.hotlistrec.loading.getAssignedOrPublishedHotLists
//   );
//   console.log(hotlists, loading);

//   useEffect(() => {
//     dispatch(getAssignedOrPublishedHotLists());
//   }, [dispatch]);

//   const handleOpenDrawer = (hotlist) => {
//     setSelectedHotlist(hotlist);
//     setShowDrawer(true);
//   };

//   const handleCloseDrawer = () => {
//     setShowDrawer(false);
//     setSelectedHotlist(null);
//   };

//   return (
//     <Box sx={{ p: "14px" }}>
//       <Box sx={{ display: "flex", gap: 2, mb: 2, mt: 1 }}>
//         <Box
//           sx={{
//             borderRadius: "3px",
//             backgroundColor: "#ffff",
//             padding: "10px",
//             width: "100%",
//             display: "flex",
//             gap: 2,
//             pt: "15px",
//           }}
//         >
//           <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
//             <TextField
//               label="Bench Sales Name or Email ID"
//               variant="outlined"
//               size="small"
//             />
//             <TextField label="Company Name" variant="outlined" size="small" />

//             <TextField
//               label="From Date"
//               variant="outlined"
//               size="small"
//               type="date"
//               InputLabelProps={{ shrink: true }}
//             />
//             <TextField
//               label="to Date"
//               variant="outlined"
//               size="small"
//               type="date"
//               InputLabelProps={{ shrink: true }}
//             />
//           </Box>
//           <Button
//             variant="contained"
//             sx={{
//               backgroundColor: "#00b0f0",
//               textTransform: "capitalize",
//               borderRadius: "3px",
//               boxShadow: "none",
//               "&:hover": {
//                 backgroundColor: "#0085b4",
//                 boxShadow: "none",
//               },
//             }}
//           >
//             Search
//           </Button>
//         </Box>
//       </Box>
//       {hotlists?.map((hotlist, index) => (
//         <Box
//           key={index}
//           sx={{
//             mb: 1,
//             px: "10px",
//             py: "8px",
//             display: "flex",
//             justifyContent: "space-between",
//             border: "1px solid #e0e0e0",
//             bgcolor: "#ffff",
//             borderRadius: "3px",
//           }}
//         >
//           <Box>
//             <Typography variant="h6">
//               {hotlist?.bench_sell_recruiter?.profiles[0]?.fullName}
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               {hotlist?.bench_sell_recruiter?.profiles[0]?.designation} -{" "}
//               {hotlist?.bench_sell_recruiter?.profiles[0]?.company}
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               {hotlist?.bench_sell_recruiter?.profiles[0]?.email}
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               {hotlist?.hotlists?.length} Hot List Available
//             </Typography>
//           </Box>
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 2.5,
//               justifyContent: "flex-end",
//             }}
//           >
//             <Typography variant="body2" color="text.secondary">
//               {shortDateTime(hotlist?.hotlists[0]?.updated_at) || "N/A"}
//             </Typography>
//             <Button
//               variant="contained"
//               onClick={() => handleOpenDrawer(hotlist)}
//               sx={{
//                 backgroundColor: "#00b0f0",
//                 textTransform: "capitalize",
//                 borderRadius: "3px",
//                 boxShadow: "none",
//                 "&:hover": {
//                   backgroundColor: "#0085b4",
//                   boxShadow: "none",
//                 },
//               }}
//             >
//               Check Hotlist
//             </Button>
//           </Box>
//         </Box>
//       ))}
//       {showDrawer && (
//         <HotListDrawer
//           show={showDrawer}
//           handleClose={handleCloseDrawer}
//           hotlist={selectedHotlist}
//         />
//       )}
//     </Box>
//   );
// };

// export default HotlistItRec;

import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import HotListDrawer from "./HotListDrawer";
import { getAssignedOrPublishedHotLists } from "../../redux/hotlist/hotListRecSlice";
import { useDispatch, useSelector } from "react-redux";
import { shortDateTime } from "../../utils/const";

const HotlistItRec = () => {
  const dispatch = useDispatch();
  const [showDrawer, setShowDrawer] = useState(false);
  const [selectedHotlist, setSelectedHotlist] = useState(null);
  const hotlists = useSelector((state) => state.hotlistrec.hotLists);
  const loading = useSelector(
    (state) => state.hotlistrec.loading.getAssignedOrPublishedHotLists
  );
  console.log(hotlists, selectedHotlist);
  // State for search inputs
  const [searchParams, setSearchParams] = useState({
    nameOrEmail: "",
    company: "",
    fromDate: "",
    toDate: "",
  });

  // State for filtered hotlists
  const [filteredHotlists, setFilteredHotlists] = useState([]);

  useEffect(() => {
    dispatch(getAssignedOrPublishedHotLists());
  }, [dispatch]);

  // Initialize filteredHotlists with all hotlists when hotlists change
  useEffect(() => {
    setFilteredHotlists(hotlists);
  }, [hotlists]);

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchParams((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const filterHotlists = () => {
    let filtered = hotlists;

    if (searchParams.nameOrEmail) {
      const searchTerm = searchParams.nameOrEmail.toLowerCase();
      filtered = filtered.filter((hotlist) => {
        const fullName =
          hotlist?.bench_sell_recruiter?.profiles[0]?.fullName?.toLowerCase() ||
          "";
        const email =
          hotlist?.bench_sell_recruiter?.profiles[0]?.email?.toLowerCase() ||
          "";
        return fullName.includes(searchTerm) || email.includes(searchTerm);
      });
    }

    if (searchParams.company) {
      const companyTerm = searchParams.company.toLowerCase();
      filtered = filtered.filter((hotlist) =>
        hotlist?.bench_sell_recruiter?.profiles[0]?.company
          ?.toLowerCase()
          .includes(companyTerm)
      );
    }

    if (searchParams.fromDate) {
      filtered = filtered.filter((hotlist) => {
        const updatedAt = new Date(hotlist?.hotlists[0]?.updated_at);
        const fromDate = new Date(searchParams.fromDate);
        return updatedAt >= fromDate;
      });
    }

    if (searchParams.toDate) {
      filtered = filtered.filter((hotlist) => {
        const updatedAt = new Date(hotlist?.hotlists[0]?.updated_at);
        const toDate = new Date(searchParams.toDate);
        return updatedAt <= toDate;
      });
    }

    setFilteredHotlists(filtered);
  };

  const handleClearSearch = () => {
    setSearchParams({
      nameOrEmail: "",
      company: "",
      fromDate: "",
      toDate: "",
    });
    setFilteredHotlists(hotlists);
  };

  const handleOpenDrawer = (hotlist) => {
    setSelectedHotlist(hotlist);
    setShowDrawer(true);
  };

  const handleCloseDrawer = () => {
    setShowDrawer(false);
    setSelectedHotlist(null);
  };

  return (
    <Box sx={{ p: "14px" }}>
      <Box sx={{ display: "flex", gap: 2, mb: 2, mt: 1 }}>
        <Box
          sx={{
            borderRadius: "3px",
            backgroundColor: "#ffff",
            padding: "10px",
            width: "100%",
            display: "flex",
            gap: 2,
            pt: "15px",
          }}
        >
          <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
            <TextField
              label="Bench Sales Name or Email ID"
              variant="outlined"
              size="small"
              name="nameOrEmail"
              value={searchParams.nameOrEmail}
              sx={{ width: "25%" }}
              onChange={handleSearchChange}
            />
            <TextField
              label="Company Name"
              variant="outlined"
              size="small"
              name="company"
              value={searchParams.company}
              onChange={handleSearchChange}
            />
            <TextField
              label="From Date"
              variant="outlined"
              size="small"
              type="date"
              name="fromDate"
              value={searchParams.fromDate}
              onChange={handleSearchChange}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="To Date"
              variant="outlined"
              size="small"
              type="date"
              name="toDate"
              value={searchParams.toDate}
              onChange={handleSearchChange}
              InputLabelProps={{ shrink: true }}
            />
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              variant="contained"
              onClick={filterHotlists}
              sx={{
                backgroundColor: "#00b0f0",
                textTransform: "capitalize",
                borderRadius: "3px",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#0085b4",
                  boxShadow: "none",
                },
              }}
            >
              Search
            </Button>
            <Button
              variant="outlined"
              onClick={handleClearSearch}
              sx={{
                textTransform: "capitalize",
                borderRadius: "3px",
                borderColor: "#00b0f0",
                color: "#00b0f0",
                "&:hover": {
                  borderColor: "#0085b4",
                  color: "#0085b4",
                },
              }}
            >
              Clear
            </Button>
          </Box>
        </Box>
      </Box>
      {filteredHotlists?.map((hotlist, index) => (
        <Box
          key={index}
          sx={{
            mb: 1,
            px: "10px",
            py: "8px",
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid #e0e0e0",
            bgcolor: "#ffff",
            borderRadius: "3px",
          }}
        >
          <Box>
            <Typography variant="h6">
              {hotlist?.bench_sell_recruiter?.profiles[0]?.fullName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {hotlist?.recruiter_designation} - {hotlist?.company_name || ""}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {hotlist?.bench_sell_recruiter?.profiles[0]?.email}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {hotlist?.hotlists?.length} Hot List Available
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2.5,
              justifyContent: "flex-end",
            }}
          >
            <Typography variant="body2" color="text.secondary">
              {shortDateTime(hotlist?.hotlists[0]?.updated_at) || "N/A"}
            </Typography>
            <Button
              variant="contained"
              onClick={() => handleOpenDrawer(hotlist)}
              sx={{
                backgroundColor: "#00b0f0",
                textTransform: "capitalize",
                borderRadius: "3px",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#0085b4",
                  boxShadow: "none",
                },
              }}
            >
              Check Hotlist
            </Button>
          </Box>
        </Box>
      ))}
      {showDrawer && (
        <HotListDrawer
          show={showDrawer}
          handleClose={handleCloseDrawer}
          hotlist={selectedHotlist}
        />
      )}
    </Box>
  );
};

export default HotlistItRec;
